<div class="language-selector" (click)="$event.stopPropagation()">
  <button type="button" class="lang-trigger" (click)="toggleDropdown($event)" [attr.aria-expanded]="isOpen">
    {{ langFlags[currentLang] }}
  </button>

  @if (isOpen) {
  <div class="lang-dropdown">
    @for (lang of availableLangs; track lang) {
    <button type="button" class="lang-option" [class.active]="lang === currentLang"
      (click)="changeLanguage(lang, $event)">
      <span class="lang-flag">{{ langFlags[lang] }}</span>
      <span class="lang-name">{{ langNames[lang] }}</span>
    </button>
    }
  </div>
  }
</div>
